<template>
  <div class="mail">
    <nav class="robbing-nav">
      <div class="robbing-nav-item" @click="gotoSendExpress">预约寄件</div>
      <div class="robbing-nav-item select">价格表</div>
    </nav>

    <img v-if="yunfeiPic" :src="yunfeiPic" class="pic" />
    <div class="empty-data" v-else>
      <div>
        <i class="iconfont icon-similarproduct"></i>
      </div>
      <div>
        <p>暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import weui from "weui.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      yunfeiPic: ""
    };
  },
  created() {
    this.encodeToken = this.$route.params.token;
    this.yunfeiPic = this.$route.params.pic;
  },
  methods: {
      gotoSendExpress() {
          this.$router.push("/expressTotakein/"+this.encodeToken);
      }
  }
};
</script>

<style scoped>
.mail {
  font-size: 16px;
  margin: 0 auto;
}
.mail .mail-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
}
.robbing-nav {
  display: flex;
  height: 50px;
  line-height: 50px;
  font-weight: bold;
  text-align: center;
  font-size: 16px;
}
.robbing-nav-item {
  flex: 1;
  font-weight: bold;
  border-bottom: 1px solid #eee;
  border-right: 1px solid #eee;
}
.robbing-nav-item:last-child {
  border-right: none;
}
.robbing-nav-item.select {
  color: red;
  border-bottom: 1px solid red;
}
.pic {
  width: 100%;
}
.empty-data {
  text-align: center;
  margin-top: 50px;
}
.empty-data div i {
  font-size: 120px;
  color: #cccccc;
}
.empty-data div p {
  font-size: 30px;
  color: #cccccc;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/Yunfei.vue